import { useConfig } from '../../context/ConfigContext';

const planSuffix = (shopPlan) => {
    if (!shopPlan) {
        return 'base';
    }
    return shopPlan.toLowerCase().replace(/_/g, '-');
};

const planShortMark = (shopPlan) => {
    switch (shopPlan) {
        case 'PRO':
            return 'Pro';
        case 'MULTI':
            return 'M';
        case 'MULTI_PLUS':
            return 'M+';
        default:
            return 'B';
    }
};

export default function MenuPlanBadge({ isOpen }) {
    const { shopPlanInfo } = useConfig();

    if (!shopPlanInfo?.shopPlanDisplayName) {
        return null;
    }

    const suffix = planSuffix(shopPlanInfo.shopPlan);
    const displayName = shopPlanInfo.shopPlanDisplayName;
    const fullLabel = `Plan ${displayName}`;

    return (
        <div
            className={`menu-plan menu-plan--${suffix}${isOpen ? '' : ' menu-plan--collapsed'}`}
            title={fullLabel}
            aria-label={fullLabel}
        >
            <div className="menu-plan__mark" aria-hidden="true">
                <span className="menu-plan__mark-text">{planShortMark(shopPlanInfo.shopPlan)}</span>
            </div>
            {isOpen && (
                <div className="menu-plan__copy">
                    <span className="menu-plan__label">Tu plan</span>
                    <span className="menu-plan__name">{displayName}</span>
                </div>
            )}
        </div>
    );
}
